<template>
  <div>
    <el-upload
      :action="uploadUrl"
      :show-file-list="false"
      :headers="headers"
      :data="uploadData"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :on-progress="uploadProcess"
      :with-credentials="true"
      class="upload-demo">
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <el-button v-if="newUploadFileName" size="small" type="danger" @click="deleteFile()">删除文件</el-button>
      <!-- <video v-if="fileType === 'video' && newUploadFileName" :src="videoUrl" class="avatar video-avatar" controls="controls">您的浏览器不支持视频播放</video>
      <span v-else>{{ newUploadFileName }}</span>
      <i v-if="!newUploadFileName" class="el-icon-plus avatar-uploader-icon"/> -->
      <div><el-progress v-if="progressFlag === true" :percentage="videoUploadPercent" type="circle" style="margin-top:30px"/></div>
    </el-upload>
    <!-- <P v-if="newUploadFileName" class="text"><span style="color: red">*</span>点击<el-link type="danger" @click="deleteFile()">此处</el-link>删除文件</P> -->
  </div>
</template>

<script>
export default {
  name: 'FileUpload',
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    fileType: {
      type: String,
      default: undefined
    },
    fileName: {
      type: String,
      default: undefined
    },
    uploadApi: {
      type: String,
      default: undefined
    },
    moduleName: {
      type: String,
      default: undefined
    },
    // 允许上传的最大值，M为单位
    maxSize: {
      type: Number,
      default: undefined
    }
  },
  data () {
    return {
      willDeleteFileName: '',
      newUploadFileName: this.fileName,
      progressFlag: false,
      videoUploadPercent: undefined,
      uploadUrl: process.env.FILE_BASE_API + this.uploadApi,
      videoUrl: '',
      headers: {
        Authorization: this.$cookie.get('token')
      },
      uploadData: {
        id: this.id,
        fileType: this.fileType
      }
    }
  },
  methods: {
    // 上传前回调
    beforeUpload (file) {
      if (this.maxSize && file.size / 1024 / 1024 > this.maxSize) {
        this.$message.warning('上传的文件不要超过' + this.maxSize + 'M。')
        return false
      }
      // 上传文件是否为视频
      const noVideo = ['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb'].indexOf(file.type) === -1
      if (this.fileType === 'video' && noVideo) {
        this.$message.warning(`请选择视频文件(mp4、ogg、flv、avi、wmv、rmvb格式)`)
        return false
      }
      // 上传文件是否为音频
      // const noAudio = ['audio/mp3', 'audio/ogg', 'audio/wav', 'audio/wma', 'audio/ra', 'audio/midi'].indexOf(file.type) === -1
      // if (this.fileType === 'audio' && noAudio) {
      //     this.$message.warning(`请选择音频文件`)
      //     return false
      // }
      if (this.fileName) {
        this.willDeleteFileName = this.newUploadFileName
      }
    },
    // 进度条
    uploadProcess (event, file, fileList) {
      this.progressFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },

    // 上传成功回调
    handleSuccess (res, file) {
      if (res.rel) {
        this.progressFlag = false
        this.videoUploadPercent = 0
        if (this.fileType === 'video') {
          this.videoUrl = res.data.http
        }
        this.newUploadFileName = res.data.http

        this.$emit('videoPath', res.data.http)
        // 删除替换的文件
        if (this.willDeleteFileName) {
          // request({
          //   url: process.env.BASE_API + this.deleteFileApi,
          //   method: 'delete',
          //   params: { fileName: this.willDeleteFileName }
          // })
        }
        this.$message.success('上传成功!')
      } else {
        this.$message.error('上传失败!')
      }
    },
    deleteFile () {
      this.$confirm(`确定要删除文件?，删除后不能恢复！`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.videoUrl = ''
        this.newUploadFileName = ''
        this.$emit('videoPath', '')
      })
    }
  }
}
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .video-avatar {
    width: 400px;
    height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Upload/CtmspOneVideoUpload.vue